import { useAuth } from "../../../context/AuthContext";
import { Navigate } from "react-router-dom";
import { UserRoles } from "../../../types/user.types";
import { ErrorMessage } from "../../../components/error-message";
import { useEffect } from "react";
import { useTeam } from "../../../context/TeamContext";
import { TeamInfoPrimaryUser } from "../team-information/team-info-primary-user";
import { TeamInfoDisplay } from "../team-information/team-info-display";
import { Loading } from "../../../components/loading";
import bgCreateTeam from "../../../assets/bgCreateTeam.jpg";
import { ShipWheel } from "lucide-react";

export function MyTeam() {
  const { user } = useAuth();
  const { getTeam, isLoading, error, team } = useTeam();

  useEffect(() => {
    getTeam();
  }, [getTeam]);

  if (
    ![UserRoles.PRIMARY_USER, UserRoles.INVITED_USER].includes(user!.roleId)
  ) {
    return <Navigate to="/unauthorized" />;
  }

  return (
    <div
      className="flex min-h-screen items-center justify-center bg-cover bg-center relative bg-fixed overflow-hidden"
      style={{ backgroundImage: `url(${bgCreateTeam})` }}
    >
      <div className="absolute inset-0 bg-black opacity-50 z-0" />{" "}
      <div className="relative w-full sm:max-w-lg lg:max-w-xl p-8 bg-[#F8F9FA] shadow-xl rounded-2xl bg-opacity-80 text-gray-900 border border-gray-300 z-10 my-4">
        <div className="flex items-center space-x-2 mb-6 justify-center">
          <ShipWheel className="h-6 w-6 text-gray-800" />
          <h1 className="text-2xl font-bold text-gray-800">Equipo</h1>
        </div>

        {error && <ErrorMessage message={error} dismissible />}
        {isLoading ? (
          <Loading />
        ) : team ? (
          <>
            {user?.roleId === UserRoles.PRIMARY_USER && (
              <TeamInfoPrimaryUser team={team} />
            )}
            {user?.roleId === UserRoles.INVITED_USER && (
              <TeamInfoDisplay team={team} />
            )}
          </>
        ) : (
          <ErrorMessage message="No se encontró el equipo." />
        )}
      </div>
    </div>
  );
}
